import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { FeatureType } from 'common/types';
import { isRetailVenue } from 'common/utils';

type Params = {
  feature?: string;
  slug?: string;
};

const SUPPORTED_FEATURES: FeatureType[] = ['venue', 'merchant', 'venue-group'];

const useIsRetail = (venues: Venue[]): boolean => {
  const { feature, slug } = useParams<Params>();

  return useMemo(() => {
    if (!feature || !slug) {
      return false;
    }

    if (!SUPPORTED_FEATURES.includes(feature as FeatureType)) {
      return false;
    }

    return venues.some(isRetailVenue);
  }, [feature, slug, venues]);
};

export default useIsRetail;
